/*eslint no-process-env:0*/

// Production specific configuration
// =================================
module.exports = {
    // Server IP
    ip: process.env.OPENSHIFT_NODEJS_IP
        || process.env.ip
        || undefined,

    // Server port
    port: process.env.OPENSHIFT_NODEJS_PORT
        || process.env.PORT
        || 4001,
    transfer: "https://transfer-test.rs-solutions.ch",
    url: "https://test.rs-lightbox.ch",
    clientContact: "https://contacts-test.rs-solutions.ch",
    apiContact: "https://contactsapi-test.rs-solutions.ch",
    officialMail: "developer@rs-solutions.ch",
    auth: "https://auth-test.rs-solutions.ch",
        sequelize: {
            host: 'kwor.myd.infomaniak.com',
            username: 'kwor_lbappuser',
            password: 'carminoDL207',
            database: 'kwor_lightbox_test',
            dialect: 'mysql',
            port: '3306'
    },
};
